"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DashedButton = function DashedButton(_ref) {
  var children = _ref.children,
      label = _ref.label,
      button = _ref.button,
      styleName = _ref.styleName,
      onClick = _ref.onClick,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "label", "button", "styleName", "onClick", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledDashedButton, _extends({
    onClick: onClick,
    className: className,
    styleName: styleName
  }, otherProps), button ? button : null, label ? /*#__PURE__*/_react.default.createElement(Label, null, label) : null, children && !button && !label ? children : null);
};

var StyledDashedButton = _styledComponents.default.div.withConfig({
  displayName: "StyledDashedButton"
})(["width:100%;height:100%;display:flex;flex-flow:column;justify-content:center;align-items:center;box-sizing:border-box;border-radius:0.5rem;cursor:pointer;transition:border 0.15s ease-in-out;padding:5rem;border:", ";background-image:", ";&:hover{border:", ";background-image:", ";}"], function (_ref2) {
  var styleName = _ref2.styleName;
  return styleName !== 'faded' ? null : '0.3rem dashed #f0f1f3';
}, function (_ref3) {
  var styleName = _ref3.styleName;
  return styleName !== 'faded' ? "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23D4D4D4FF' stroke-width='4' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")" : null;
}, function (_ref4) {
  var theme = _ref4.theme,
      styleName = _ref4.styleName;
  return styleName !== 'faded' ? null : "0.3rem dashed ".concat(theme.brand.primary);
}, function (_ref5) {
  var theme = _ref5.theme,
      styleName = _ref5.styleName;
  return styleName !== 'faded' ? "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23".concat(theme.brand.primary.substring(1), "' stroke-width='4' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")") : null;
});

var Label = _styledComponents.default.div.withConfig({
  displayName: "Label"
})(["margin-top:1.6rem;font-family:", ";font-weight:500;font-size:1.8rem;line-height:2.3rem;text-align:center;letter-spacing:0.01em;color:#222;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.font;
});

DashedButton.defaultProps = {
  styleName: 'faded'
};
DashedButton.propTypes = {
  /** Children to be used inside the button. Will only show if no label and / or button were passed. */
  children: _propTypes.node,

  /** Text to be displayed inside the button. */
  label: _propTypes.string,

  /** Element to be displayed inside the button above the label. */
  button: _propTypes.element,

  /** Pass a styleName name to edit the visuals of the button. */
  styleName: _propTypes.string,

  /** Function to be ran when the element is clicked */
  onClick: _propTypes.func.isRequired,

  /** Extra classNames to be passed to the StyledDashedButton. */
  className: _propTypes.string,

  /** Adds extra props to the element. */
  otherProps: _propTypes.object
};
var _default = DashedButton;
exports.default = _default;